import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export class SnackbarMessageParams {
  public msg:string;
  public icon:string;
  public svgIcon:string;

  constructor(_msg:string = '', _icon:string = 'check_circle_outline', _svgIcon:string= null){
    this.msg = _msg;
    this.icon = _icon;
    this.svgIcon = _svgIcon;
  }
}

@Component({
  selector: 'terra-snackbar-message',
  templateUrl: './snackbar-message.component.html',
  styleUrls: ['./snackbar-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarMessageComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarMessageParams) {}

  ngOnInit(): void {
  }

}
